import { Controller } from "@hotwired/stimulus"

// Polls /processos/sync_status.json every 2s while a sync is running.
// Stops when in_progress becomes false or after 5min timeout.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.timeoutAt = Date.now() + 300_000
    this.boundPoll = this.poll.bind(this)
    this.boundStart = this.startPolling.bind(this)
    document.addEventListener("processos:sync-started", this.boundStart)
  }

  disconnect() {
    this.stopPolling()
    document.removeEventListener("processos:sync-started", this.boundStart)
  }

  startPolling() {
    this.stopPolling()
    this.timeoutAt = Date.now() + 300_000
    this.intervalId = setInterval(this.boundPoll, 2000)
    this.poll()
  }

  stopPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  async poll() {
    if (Date.now() > this.timeoutAt) {
      this.stopPolling()
      return
    }
    try {
      const res = await fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      if (!res.ok) return
      const data = await res.json()
      if (data.in_progress === false && data.status !== "never_run") {
        this.stopPolling()
        location.reload()
      }
    } catch (e) {
      // erro de rede transitório — próxima tick tenta de novo
    }
  }
}
